import axios from "axios";

export default function getTransactionReport({ date }) {
  return new Promise((resolve, reject) =>
    axios
      .get(`/campaignV2/transactionReport/getReportDetails?date=${date}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
